
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SurveyTemplate } from "../../../models/SurveyTemplates";
import { LoadableContext, RootState } from "../../store";


interface SelectedSurveyTemplateState extends LoadableContext {
    template: SurveyTemplate | null;
}

const initialState: SelectedSurveyTemplateState = {
    template: null,
    loading: false,
    error: null,
};

export const selectedSurveyTemplateSlice = createSlice({
    name: 'selected_survey_template',
    initialState,
    reducers: {
        startLoading: (state) => {
            state.loading = true;
            state.error = null;
        },
        stopLoading: (state) => {
            state.loading = false;
            state.error = null;
        },
        setSelected: (state, { payload: template }: PayloadAction<SurveyTemplate | null>) => {
            state.template = template;
            state.loading = false;
            state.error = null;
        },
        updateSelected: (state, { payload: updates }: PayloadAction<Partial<SurveyTemplate>>) => {
            if (state.template) {
                state.template = { ...state.template, ...updates };
            }
        },
        clearSelected: (state) => {
            state.template = null;
            state.loading = false;
            state.error = null;
        },
        setError: (state, { payload }: PayloadAction<string>) => {
            state.loading = false;
            state.error = payload;
        },
    }
});

export const SelectedSurveyTemplateActions = {
    ...selectedSurveyTemplateSlice.actions,
};

// Selectors
export const selectSelectedSurveyTemplate = (state: RootState) => state.surveyTemplates.selected.template;
export const selectSelectedSurveyTemplateLoading = (state: RootState) => state.surveyTemplates.selected.loading;
export const selectSelectedSurveyTemplateError = (state: RootState) => state.surveyTemplates.selected.error;

const SelectedSurveyTemplateReducer = selectedSurveyTemplateSlice.reducer;
export default SelectedSurveyTemplateReducer;
